module.exports = __webpack_public_path__ + "img/product-preview-48.9638ea0.png";